import { doc, updateDoc, writeBatch, Timestamp } from 'firebase/firestore';
import { db } from '../../config';
import { batchStatus } from '../../../../constants/enum';

interface UpdateMasterParams {
  masterId: string;
  fileSize?: string;
  rowCount?: number;
  csvColumns?: string[];
  uploadedByUid: string;
  uploadedByName: string;
  uploadedByIcon: string | null;
  // 代理ログイン中の差し替えか（#3343）。true のとき uploadedByName には「事務局」を渡す。
  isProxy?: boolean;
  // 代理操作した運営スタッフの UID（#3343）。代理でなければ undefined。
  operatorId?: string | null;
}

export const updateMaster = async (params: UpdateMasterParams): Promise<void> => {
  const masterRef = doc(db, 'masters', params.masterId);

  const isProxy = params.isProxy === true;

  const updateData: Record<string, string | number | boolean | string[] | Timestamp | null> = {
    uploaded_by_uid: params.uploadedByUid,
    uploaded_by_name: params.uploadedByName,
    uploaded_by_icon: params.uploadedByIcon,
    // 代理操作の記録（#3343）。差し替えでアップロード者が変わるため、
    // 代理でない場合も false / null を明示して前回の代理記録を消す。
    is_proxy: isProxy,
    operator_id: isProxy ? params.operatorId || null : null,
    updated_at: Timestamp.now(),
  };

  if (params.fileSize !== undefined) updateData.file_size = params.fileSize;
  if (params.rowCount !== undefined) updateData.row_count = params.rowCount;
  if (params.csvColumns !== undefined) updateData.csv_columns = params.csvColumns;

  // CSV差し替えでも取り込みジョブが動くため、新規登録（create.ts）と同じく処理中にする（#3336）。
  // 書かないと前回の completed が残り、差し替え直後に「処理中」が表示されない。
  updateData.batch_status = batchStatus.processing;

  await updateDoc(masterRef, updateData);
};

/**
 * 複数マスタの display_order を一括更新する（#3135）。
 *
 * 並べ替えは内容の変更ではないため updated_at は更新しない
 * （一覧の「更新日」が全行ドラッグのたびに書き変わるのを避ける）。
 *
 * @param orderedMasterIds 表示順に並んだマスタIDの配列
 */
export const updateMastersDisplayOrder = async (orderedMasterIds: string[]): Promise<void> => {
  const batch = writeBatch(db);

  orderedMasterIds.forEach((masterId, index) => {
    const masterRef = doc(db, 'masters', masterId);
    batch.update(masterRef, { display_order: index });
  });

  await batch.commit();
};
